var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"company-introduction-view"},[_c('IntroductionContent1'),_c('IntroductionContent2'),_c('IntroductionContent3'),_c('IntroductionContent4'),_c('IntroductionContent5'),(_vm.showFooter)?_c('HomeFooter'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }